import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import "./whatsAppIcon.css";

const WhatsAppIcon = () => {
  return (
    <div className="whatsapp-container">
      <a
        href={SITE.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
        aria-label="WhatsApp ile iletişime geçin"
      >
        <FaWhatsapp size={50} />
      </a>
    </div>
  );
};

export default WhatsAppIcon;
